module.exports = __webpack_public_path__ + "static/media/mewtwo_0.e0ded0c7.png";